<template>
    <v-footer style="white-space:pre">
        {{appName}} {{version}} | <router-link
            to="/release-notes"
        >
            Release Notes
        </router-link> | © {{year}} <a :href="url">{{companyName}}</a> All rights reserved
        <span
            v-if="envMessage"
            style="color: red; margin-left: auto;"
        >
            <span>{{ envMessage }}</span>
        </span>
    </v-footer>
</template>
<script>
import Vue from 'vue'

export default Vue.extend({
    mounted() {
        const envs = ['demo.', 'staging.', 'uat.', 'localhost']
        const findEnv = envs.find(env => window.location.hostname.includes(env))
        if(findEnv) {
            this.envMessage = findEnv === 'demo.' ? '*** THIS ENVIRONMENT IS FOR DEMONSTRATION USE ONLY ***' : '*** THIS ENVIRONMENT IS FOR TESTING USE ONLY ***'
        }
    },
    data() {
        return {
            url: 'https://www.stackdynamicscorp.com',
            companyName: 'Stack Dynamics Corp.',
            appName: 'PropConn',
            version: process.env.VUE_APP_VERSION,
            year: new Intl.DateTimeFormat('en',{year:'numeric'}).format(new Date),
            envMessage: ''
        }
    },
})
</script>
